import http from '../../http'
export default {
    list: (params) => {
        return http.post('activityservice/quota/page', params)
    },
    update: (params) => {
        return http.post('activityservice/quota/upsert', params)
    },
    delAll: (params) => {
        return http.post('activityservice/quota/batch', params)
    }
}
